
// Main compare list
class ProductsCompareList extends HTMLElement {
    constructor() {
      super();
      this.LS_KEY = 'theme:compare:ids';
      this.STORE_URL = shopUrl;
      this.API_TOKEN = this.dataset.compareToken;
      this.API_VERSION = '2025-01';
      this.API_URL = `${this.STORE_URL}/api/${this.API_VERSION}/graphql.json`;
      this.compareTb = this.querySelector(".product-compare-table");
    }

    get compareList() {
        const stored = localStorage.getItem(this.LS_KEY);
        return stored ? JSON.parse(stored) : [];
    }

    set compareList(newList) {
      if (Array.isArray(newList)) {
        localStorage.setItem(this.LS_KEY, JSON.stringify(newList));
        document.dispatchEvent(new Event("compare-list-updated"));
        } else {
          console.error("compareList setter expects an array.");
        }
    }

    async connectedCallback() {
      const dataHtml = await this.fetchSection();
      if (!dataHtml) return;

      this.renderHTML(dataHtml);
      document.addEventListener("compare-list-updated", async () => {
        const updatedDataHtml = await this.fetchSection();
        this.renderHTML(updatedDataHtml);
      });      
    }

    renderHTML(newHtml){
      const tempElement = document.createElement('div');
      tempElement.innerHTML = newHtml;

      const newThis = tempElement.querySelector("products-compare-list");
      if (newThis && this) {
        this.innerHTML = newThis.innerHTML;
      } else {
        console.warn('something wrong in render html in products-compare-list.js');
      }
    }

    async fetchSection(){
      const ids = this.compareList;
      this.querySelector(".product-compare-inner").classList.add("loading");
      const searchQuery = ids.map(id => `id:${id}`).join(' OR ');

      try {
        const res = await fetch(`${this.dataset.searchUrl}?section_id=${this.dataset.sectionId}&type=product&q=${searchQuery}`)
        if (!res.ok) {
           throw new Error(`HTTP error ${res.status}`);
        }
        return await res.text();
      } catch (error) {
        console.error("Failed to fetch compare products:", error);
      } finally{
        this.querySelector(".product-compare-inner").classList.remove("loading");
      }
    }

}

if(!customElements.get("products-compare-list")) customElements.define("products-compare-list", ProductsCompareList)

// Compare page btn
class ComparePageBtn extends ProductsCompareList {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector(".js-compare-counter");
    this.updateButtonState();

    this.addEventListener("click", () => {
      window.location.href = "/pages/compare";
    });

    document.addEventListener("compare-list-updated", () => {
      this.updateButtonState();
    });
  }

  updateButtonState() {
    const list = this.compareList;
    if (!list.length) {
      this.setAttribute("hidden", "");
    } else {
      this.removeAttribute("hidden");
      if (this.button) {
        this.button.innerText = list.length;
      }
    }
  }
}

if (!customElements.get("compare-page-btn")) {
  customElements.define("compare-page-btn", ComparePageBtn);
}


// Compare Checkbox in Product cards
class ProductCompare extends ProductsCompareList {
  constructor() {
      super();
  }
  
  connectedCallback() {
      this.addEventListener("change", this.handleChange); 
      this.compareList.forEach((item) => {
          const inputToCheck = this.querySelector(`input[value="${item}"]`);
          if (inputToCheck) {
              inputToCheck.checked = true;
          }
      });
  }

  disconnectedCallback() {
      this.removeEventListener("change", this.handleChange);
  }

  handleChange = (e) => {
      const productId = this.dataset.product;
      const isChecked = e.target.checked;
      let currentList = this.compareList; 
      
      if (isChecked) {
          if (!currentList.includes(productId)) {
              currentList.push(productId);
          }
      } else {
          currentList = currentList.filter(item => item !== productId);
      }
      
      this.compareList = currentList; 
  }
}

if (!customElements.get("product-compare")) {
  customElements.define("product-compare", ProductCompare);
}